import type { ReferralListFilters } from '@hv/shared';

export const REFERRAL_FILTER_KEYS = ['status', 'trustee', 'grade', 'school', 'stage', 'dup', 'search', 'from', 'to'] as const;

export function referralFiltersFromParams(params: URLSearchParams, cycleId: string | undefined): ReferralListFilters {
  const get = (k: (typeof REFERRAL_FILTER_KEYS)[number]) => params.get(k) || undefined;
  return {
    cycleId,
    status: get('status') as ReferralListFilters['status'],
    trusteeUserId: get('trustee'),
    grade: get('grade'),
    school: get('school'),
    stage: get('stage') as ReferralListFilters['stage'],
    duplicateStatus: get('dup') as ReferralListFilters['duplicateStatus'],
    q: get('search'),
    submittedFrom: get('from'),
    submittedTo: get('to'),
  };
}

export function referralFilterParams(params: URLSearchParams, cycleId: string | undefined): URLSearchParams {
  const out = new URLSearchParams();
  if (cycleId) out.set('cycle', cycleId);
  for (const k of REFERRAL_FILTER_KEYS) {
    const v = params.get(k);
    if (v) out.set(k, v);
  }
  return out;
}

const FILTER_PARAMS: [keyof ReferralListFilters, (typeof REFERRAL_FILTER_KEYS)[number]][] = [
  ['status', 'status'],
  ['trusteeUserId', 'trustee'],
  ['grade', 'grade'],
  ['school', 'school'],
  ['stage', 'stage'],
  ['duplicateStatus', 'dup'],
  ['q', 'search'],
  ['submittedFrom', 'from'],
  ['submittedTo', 'to'],
];

export function referralsHref(filters: ReferralListFilters): string {
  const params = new URLSearchParams();
  if (filters.cycleId) params.set('cycle', filters.cycleId);
  for (const [key, param] of FILTER_PARAMS) {
    const value = filters[key];
    if (value) params.set(param, value);
  }
  const query = params.toString();
  return query ? `/referrals?${query}` : '/referrals';
}
